import React, {useState, useEffect} from 'react';
import {Container, Chip, Grid, List, ListItem, ListItemIcon, ListItemText, Divider} from '@material-ui/core/';
import {NavigateNext} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {AccountCircle, Email, Filter1, Today, LocationOn, Call, Wc, Person, InsertComment } from '@material-ui/icons';

function DatosCiudadano(props) {   
    const classes = useStyles()

    useEffect(() => {
        // console.log('props.datosResidencia: ', props)
    }, [props.datosResidencia])

    return (
        <Grid container >               
            <Grid item xs={12}>
                <div className={classes.centerTitlePrincipal}><Divider /> <strong>PROFESIÓN U OFICIO</strong> <Divider /></div>
            </Grid >               
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Profesión u Oficio: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>                
            </Grid >                       
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.data?.profesion?.name}/>
            </Grid >
            {
                (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) ?''
                :(
                    <>
                        <Grid item xs={12}>
                            <div className={classes.centerTitle}><Divider /> <strong>RESIDENCIA ELECTORAL ASIGNADA</strong> <Divider /></div>
                        </Grid >             
                        <Grid item xs={3}>
                            <ListItem className={classes.rootListItem}>
                                <ListItemText className={classes.rootListItemText} primary="Dirección: " />
                                <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                            </ListItem>                
                        </Grid >                         
                        <Grid item xs={3}>
                            <Chip variant="outlined" className={classes.colorChip} label={props.datos.direccion}/>
                        </Grid > 
                        <Grid item xs={3}>
                            <ListItem className={classes.rootListItem}>
                                <ListItemText className={classes.rootListItemText} primary="No. Casa/Lote: " />
                                <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                            </ListItem>                
                        </Grid >                   
                        <Grid item xs={3}>
                            <Chip variant="outlined" className={classes.colorChip} label={props.datos.nocasalote} />
                        </Grid >       
                        <Grid item xs={3}>
                            <ListItem className={classes.rootListItem}>
                                <ListItemText className={classes.rootListItemText} primary="Zona: " />
                                <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                            </ListItem>                
                        </Grid >                               
                        <Grid item xs={3}>
                            <Chip variant="outlined" className={classes.colorChip} label={props.datos.zona} />
                        </Grid >                               
                        <Grid item xs={3}>
                            <ListItem className={classes.rootListItem}>
                                <ListItemText className={classes.rootListItemText} primary="Departamento: " />
                                <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                            </ListItem>                
                        </Grid >                   
                        <Grid item xs={3}>
                            <Chip variant="outlined" className={classes.colorChip} label={props.data?.departamento?.name} />
                        </Grid >                
                        <Grid item xs={3}>
                            <ListItem className={classes.rootListItem}>
                                <ListItemText className={classes.rootListItemText} primary="Municipio: " />
                                <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                            </ListItem>                
                        </Grid >                      
                        <Grid item xs={3}>
                            <Chip variant="outlined" className={classes.colorChip} label={props.data?.municipio?.name} />
                        </Grid >                      
                        <Grid item xs={3}>
                            <ListItem className={classes.rootListItem}>
                                <ListItemText className={classes.rootListItemText} primary="Comunidad: " />
                                <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                            </ListItem>                
                        </Grid >                   
                        <Grid item xs={3}>
                            <Chip variant="outlined" className={classes.colorChip} label={props.data?.comunidad?.name} />
                        </Grid >    
                    </>
                )
            }
            <Grid item xs={12}>
                <div className={classes.centerTitlePrincipal}><Divider /> <strong>CORREO</strong> <Divider /></div>
            </Grid >                           
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Correo Electrónico: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>                
            </Grid >                   
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.data.email} />
            </Grid >    
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>Observaciones</strong> <Divider /></div>
            </Grid >                            
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Observación: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>                
            </Grid >                   
            <Grid item xs={9}>
                <Chip variant="outlined" className={classes.colorChip} label={props.data.observaciones} />
            </Grid >                            
        </Grid >             
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadano);